import { Button, Row, TabItemType, Tabs, TextInput, Typography } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { CustomTabs } from 'modules/classes/styles/tab';

import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { COLOR } from 'constants/color';

import { RolePermission } from '../components/RolePermission';
import { usePermissionsController } from '../core/controller';
import { PermissionTab } from '../core/enum';

const PermissionsPage = () => {
  const {
    roles,
    groupPermissons,
    selectedPermissions,
    handleChangePermission,
    onSubmit,
    activeKey,
    onTabClick,
    isEdit,
    handleCancel,
    searchValue,
    onChangeSearchValue,
  } = usePermissionsController();

  const getPermissionTabs = (): TabItemType[] => {
    return [
      {
        label: 'Web permissions',
        key: PermissionTab.WEB,
        children: <></>,
      },
      {
        label: 'App permissions',
        key: PermissionTab.APP,
        children: <></>,
      },
    ];
  };

  if (!roles || !groupPermissons) return null;

  const permissions =
    activeKey === PermissionTab.WEB
      ? groupPermissons?.groupPermissionWebs
      : groupPermissons?.groupPermissionMobiles;

  const listRole =
    activeKey === PermissionTab.WEB
      ? roles.filter((role) => role.key !== RoleKey.BIOLOGIC_ADMIN && role.key !== RoleKey.LEARNER)
      : roles.filter(
          (el) => el.key !== RoleKey.BIOLOGIC_ADMIN && el.key !== RoleKey.INSTITUTION_ADMIN,
        );

  const buttonStyle = {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 600,
    height: 44,
    padding: '0 24px',
    color: COLOR.surfaceNeutralBold['neutral-11'],
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16,
        }}
      >
        <Typography
          style={{ fontSize: 24, lineHeight: '34px' }}
          weight={500}
          color={COLOR.surfaceNeutralBold['neutral-11']}
        >
          Roles permissions
        </Typography>
        <div>
          {isEdit.value ? (
            <Row align="center">
              <Button
                variant="outlined"
                type="submit"
                size="medium"
                style={{
                  marginRight: 12,
                  ...buttonStyle,
                }}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="medium"
                style={{
                  ...buttonStyle,
                  color: '#FFFFFF',
                }}
                onClick={onSubmit}
              >
                Save
              </Button>
            </Row>
          ) : (
            <Button
              icon={<EditIcon style={{ marginRight: 4, width: 20, height: 20 }} />}
              placementIcon="left"
              style={{
                ...buttonStyle,
              }}
              onClick={() => isEdit.setValue(true)}
            >
              Edit permissions
            </Button>
          )}
        </div>
      </div>

      <CustomTabs>
        <Tabs
          variant="text"
          items={getPermissionTabs()}
          activeKey={activeKey}
          onTabClick={onTabClick}
          tabItemStyle={{
            height: 44,
            background: 'transparent',
            fontSize: '18px',
            lineHeight: '26px',
            fontWeight: 600,
          }}
          isLine={true}
        />
      </CustomTabs>

      <TextInput
        placeholder="Search for permission"
        prefix={<SearchIcon />}
        inputStyle={{
          backgroundColor: 'transparent',
          width: 400,
          borderRadius: 12,
        }}
        containerStyle={{
          maxWidth: 'auto',
          width: 400,
          marginBottom: 16,
          marginTop: 16,
        }}
        value={searchValue.value}
        onChange={onChangeSearchValue}
      />

      <RolePermission
        permissions={permissions}
        roles={listRole}
        selectedPermissions={selectedPermissions}
        isEdit={isEdit.value}
        handleChangePermission={handleChangePermission}
      />
    </div>
  );
};

export default PermissionsPage;
